/** Surface tones used behind product / category imagery (keys match SurfaceTone). */
export type Tone = "mint" | "cream" | "blush" | "sky" | "sage";

export const toneBg: Record<Tone, string> = {
  mint: "bg-mint",
  cream: "bg-cream",
  blush: "bg-blush",
  sky: "bg-sky",
  sage: "bg-sage",
};

/** Gradient start colour matching the tone (for image fade-outs). */
export const toneFrom: Record<Tone, string> = {
  mint: "from-mint",
  cream: "from-cream",
  blush: "from-blush",
  sky: "from-sky",
  sage: "from-sage",
};
